import React from 'react'
import { initialize, set, pageview } from 'react-ga'
import isbot from 'isbot'
import UAParser from 'ua-parser-js'

import {
  mixpanel,
  setMixpanelReferrerProperties,
  smartlookClient,
} from 'mednet-util/src/tracking'
import { isEmpty } from 'lodash'

class Tracking extends React.Component {
  componentDidMount() {
    const { history } = this.props

    try {
      if (process.env.MIXPANEL_TOKEN) {
        mixpanel.init(process.env.MIXPANEL_TOKEN, {
          loaded: () => {
            if (document) document.mixpanel_loaded = true
          },
        })

        const userId = sessionStorage.getItem('user_id')

        if (userId) {
          mixpanel.identify(userId)
          mixpanel.register({ user_id: userId }) // It is recommended by mixpanel to set user id as super property
        } else if (
          mixpanel.get_distinct_id() &&
          // if mixpanel distinct id is a number, this means it is an id from our system and not anonymous
          !isNaN(mixpanel.get_distinct_id())
        ) {
          // Clears super properties and generates a new random distinct_id for this instance.
          mixpanel.reset()
        }

        setMixpanelReferrerProperties(history.location)

        if (!isEmpty(window?.navigator?.userAgent)) {
          mixpanel.register({
            'Agent Robot': isbot(window?.navigator?.userAgent),
          })
        }

        const parser = new UAParser()
        const agent = parser.getResult()

        mixpanel.register({
          'Agent Device': agent.device
            ? {
                ...agent.device,
                type: agent.device.type || 'desktop',
              }
            : null,
          'Agent Browser': agent?.browser?.name,
          'Agent Platform': agent.os.name,
        })

        const mpLocationListener = () => {
          sessionStorage.removeItem('notification_source')
          const params = new URLSearchParams(history.location.search)
          const src = params.get('src')

          // since these changes are in react router, we can assume it is alway an internal react page
          // This is also needed as document.referrer does not change when react router changes the page
          if (src === 'popover-search') {
            mixpanel.register({
              direct_referrer_label: 'theMednet Popover Search',
              direct_referrer_search_query: params.get('query'),
            })
          } else {
            mixpanel.register({
              direct_referrer_label: 'theMednet',
              direct_referrer_search_query: null,
            })
          }
        }

        history.listen(mpLocationListener)
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}

    try {
      smartlookClient.init(process.env.SMARTLOOK_API_KEY)
      // eslint-disable-next-line no-empty
    } catch (e) {}

    if (process.env.GOOGLE_ANALYTICS_ID) {
      initialize(process.env.GOOGLE_ANALYTICS_ID)

      const locationListener = (location) => {
        set({ page: location.pathname })
        pageview(location.pathname)
      }

      locationListener(window.location)

      history.listen(locationListener)
    }
  }

  render() {
    return null
  }
}

export default Tracking
